import { Grid, Icon, InputLabel, Menu, MenuItem } from "@mui/material";
import SoftButton from "components/SoftButton";
import SoftInput from "components/SoftInput";
import SoftInputNumber from "components/SoftInputNumberUpgrade";
import SoftTypography from "components/SoftTypography";
import React, { memo, useCallback, useMemo, useState } from "react";
import PropTypes from "prop-types";
import DataTable from "components/Tables/DataTable";
import dataEquipamiento from "./dataEquipamiento";
import SoftBox from "components/SoftBox";
import { getColor } from "utils/colors";
import SinDatos from "components/Carteles/SinDatos";
import Separador from "../Separador";
import ModalAnteriores from "../ModalAnteriores";

const Equipamiento = ({
  idDeclaracion,
  listadoEquipamiento,
  setListadoEquipamiento,
  finalizada,
  idEmpresa,
}) => {
  const [equipamiento, setEquipamiento] = useState([]);
  const [openMenu, setOpenMenu] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedEquipamiento, setSelectedEquipamiento] = useState(null);
  const [modalAnteriores, setModalAnteriores] = useState(false);

  const { columns, getRows } = dataEquipamiento;

  const handleOpenMenu = useCallback((event, item) => {
    setAnchorEl(event.currentTarget);
    setOpenMenu(true);
    setSelectedEquipamiento(item);
  }, []);

  const handleCloseMenu = useCallback(() => {
    setAnchorEl(null);
    setOpenMenu(false);
    setSelectedEquipamiento(null);
  }, []);

  const handleChangeEquipamiento = (e) => {
    const { name, value } = e.target;
    setEquipamiento((prev) => ({ ...prev, [name]: value }));
  };

  const handleAddEquipamiento = (equipamiento) => {
    setListadoEquipamiento((prev) => [...prev, equipamiento]);
    setEquipamiento([]);
  };

  const memoizedRows = useMemo(() => {
    if (listadoEquipamiento) {
      const listadoSinBorrar = listadoEquipamiento.filter((item) => !item.borrado);
      return getRows(listadoSinBorrar, handleOpenMenu);
    }
    return [];
  }, [listadoEquipamiento, handleOpenMenu]);

  // Render del menú contextual
  const renderMenu = !finalizada && (
    <Menu id="simple-menu" anchorEl={anchorEl} open={Boolean(openMenu)} onClose={handleCloseMenu}>
      <MenuItem
        onClick={() => {
          handleCloseMenu();
          setListadoEquipamiento((prev) => {
            // Si no tiene ID quitar el item de la lista
            if (!selectedEquipamiento.id) {
              return prev.filter((item) => item.descripcion !== selectedEquipamiento.descripcion);
            } else {
              return prev.map((item) => {
                if (item.id == selectedEquipamiento.id) {
                  return { ...item, borrado: true };
                }
                return item;
              });
            }
          });
        }}
      >
        <SoftBox
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          sx={{ width: "100%" }}
        >
          <SoftTypography variant="p">Quitar</SoftTypography>
          <Icon fontSize="small" sx={{ verticalAlign: "middle", color: getColor("gobSecondary") }}>
            delete
          </Icon>
        </SoftBox>
      </MenuItem>
    </Menu>
  );

  return (
    <Grid container p={2}>
      <Grid item xs={12} display="flex" justifyContent="space-between" alignItems="flex-end">
        <SoftTypography variant="h4" fontWeight="bold">
          Equipamientos
        </SoftTypography>
        {!finalizada && (
          <SoftButton
            variant="outlined"
            color="dark"
            sx={{
              cursor: "pointer",
              p: 1,
            }}
            onClick={() => setModalAnteriores(true)}
            disabled={finalizada}
          >
            CARGAR ANTERIORES
            <Icon fontSize="small" sx={{ verticalAlign: "middle", color: "gobSecondary", ml: 0.5 }}>
              cached
            </Icon>
          </SoftButton>
        )}
      </Grid>
      {/* Esta sección solo mostrar si es nuevo */}
      {!finalizada && (
        <Grid item xs={12}>
          <Grid container p={2} spacing={1}>
            <Grid item xs={6} md={2}>
              <InputLabel htmlFor="tipo">
                <SoftTypography component="label" variant="caption" fontWeight="bold">
                  Tipo
                </SoftTypography>
              </InputLabel>
              <SoftInput
                id="tipo"
                placeholder="Tipo de equipamiento"
                value={equipamiento.tipo || ""}
                fullWidth
                name="tipo"
                onChange={handleChangeEquipamiento}
              />
            </Grid>
            <Grid item xs={6} md={2}>
              <InputLabel htmlFor="potencia">
                <SoftTypography component="label" variant="caption" fontWeight="bold">
                  Potencia
                </SoftTypography>
              </InputLabel>
              <SoftInput
                id="potencia"
                placeholder="Potencia de equipamiento"
                value={equipamiento.potencia || ""}
                fullWidth
                name="potencia"
                onChange={handleChangeEquipamiento}
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <InputLabel htmlFor="descripcion">
                <SoftTypography component="label" variant="caption" fontWeight="bold">
                  Descripción
                </SoftTypography>
              </InputLabel>
              <SoftInput
                id="descripcion"
                placeholder="Descripción "
                value={equipamiento.descripcion || ""}
                fullWidth
                name="descripcion"
                onChange={handleChangeEquipamiento}
              />
            </Grid>
            <Grid item xs={6} md={2}>
              <InputLabel htmlFor="cantidad">
                <SoftTypography component="label" variant="caption" fontWeight="bold">
                  Cantidad
                </SoftTypography>
              </InputLabel>
              <SoftInputNumber
                id="cantidad"
                placeholder="Cantidad"
                value={equipamiento.cantidad || ""}
                fullWidth
                onChange={handleChangeEquipamiento}
                name="cantidad"
              />
            </Grid>
            <Grid item xs={6} md={2} display={"flex"} alignItems="flex-end">
              <SoftButton
                variant="gradient"
                color="primary"
                fullWidth
                onClick={() => {
                  handleAddEquipamiento(equipamiento);
                  setEquipamiento([]);
                }}
                disabled={!equipamiento.descripcion || !equipamiento.cantidad || !equipamiento.tipo}
              >
                Agregar +
              </SoftButton>
            </Grid>
          </Grid>
        </Grid>
      )}
      {!finalizada && <Separador />}
      <Grid
        item
        xs={12}
        py={1}
        // sx={{
        //   border: "2px dashed rgb(0, 0, 0, 0.4)",
        //   borderRadius: "10px",
        // }}
      >
        {listadoEquipamiento?.length > 0 ? (
          <DataTable columns={columns} rows={memoizedRows} />
        ) : (
          <SinDatos textoTitulo="No hay equipamientos cargados" />
        )}
        {renderMenu}
      </Grid>
      <ModalAnteriores
        open={modalAnteriores}
        handleClose={() => setModalAnteriores(false)}
        idEmpresa={idEmpresa}
        setListado={setListadoEquipamiento}
        tipo="equipamiento"
      />
    </Grid>
  );
};

export default memo(Equipamiento);

Equipamiento.propTypes = {
  idDeclaracion: PropTypes.string.isRequired,
  listadoEquipamiento: PropTypes.array.isRequired,
  setListadoEquipamiento: PropTypes.func.isRequired,
  finalizada: PropTypes.bool,
  idEmpresa: PropTypes.string,
};
